import React, { useEffect, useState } from "react";
import closeicon from "../../assets/popups/close.png";
import { Skeleton } from "@mui/material";
import api from "../../api/api";

const StatusPopup = ({ isOpen, onClose, updateStatus }) => {
  const [selectedOption, setSelectedOption] = useState(null); // Track selected option (single)
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const practiseid = window.getPracticeId();

  const fetchData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await api.post(`/v1/${practiseid}/appointments/status-types`,{
    "appointment_types": [
        "check-in",
        "visit confirmation"
    ]
});
      if (response.status === 200) {
        const statusTypes = response.data
        console.log('Status Types', statusTypes);
        setStatusOptions(statusTypes);
      } else {
        setStatusOptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const handleButtonClick = (name) => {
    setSelectedOption(name); // Replace the previous selected status with the new one
  };

  const handleApplyClick = () => {
    updateStatus([selectedOption]); // Send only the selected status
    onClose(); // Close the popup after applying changes
  };

  const handleCancelClick = () => {
    setSelectedOption(null); // Reset selected option
    onClose(); // Close the popup without making any changes
  };
  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto pt-40">
        {/* Popup Box */}
        <div className="relative flex flex-col gap-4 w-[340px] bg-white px-2 pb-6 rounded-lg shadow-lg text-left">
          <div>
            <div className="w-full flex items-center justify-between mt-2 px-2">
              {/* Close Button */}
              <span className="ml-2 font-inter text-[#09090B] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
                Visit Confirmation
              </span>
              <button
                className="text-gray-500 hover:text-gray-700 text-[30px]"
                onClick={onClose}
              >
                &times;
              </button>
            </div>
          </div>

          {/* Skeleton loading */}
          {loading ? (
            <>
              {[...Array(3)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  height={40}
                  sx={{ borderRadius: "4px", margin: "8px 0" }}
                />
              ))}
            </>
          ) : (
            // Button list for selecting statuses
            <div className="flex flex-column gap-4 px-2">
            {/* Separate for 'Rescheduled', 'Cancelled', 'Active', 'No Show', 'In Office Confirmed' */}
<div className="grid grid-cols-2 gap-2 w-full mt-4">

              {statusOptions.filter(item => 
                ['Rescheduled', 'Cancelled', 'ACTIVE', 'No Show', 'In-Office - Confirmed',"No Update", "Tele - Confirmed","Tele - left VM","In-Office - left VM", "In-office - Checked In","Awaiting Check In"].includes(item.value)
              ).map((item) => (
                <button
                  key={item.value}
                  className={`py-[8px] px-2 rounded-full text-[14px] font-inter transition duration-300 ease-in-out
  ${
    selectedOption === item.value
      ? "bg-black text-white ring-2 ring-black"
      : item.value === "Ready for Triage"
      ? "bg-[#F0FDF4] text-[#50869A]"
      : item.value === "Checked Out"
      ? "bg-[#E1795459] text-[#C2410C]"
      : item.value === "Processing"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : item.value === "Ready for Checkout"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : item.value === "Ready for Provider"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : "bg-[#ECECEE] text-[#1D4ED8]"
  }
`}

                  // className={`py-[8px] px-2  rounded-full text-[14px] font-inter transition duration-300 ease-in-out ${
                  //   item.value === "Ready for Triage"
                  //     ? "bg-[#F0FDF4] text-[#50869A]"
                  //     : item.value === "Checked Out"
                  //     ? "bg-[#E1795459] text-[#C2410C]"
                  //     : item.value === "Processing"
                  //     ? "bg-[#DBEAFE] text-[#1D4ED8]"
                  //     : item.value === "Ready for Checkout"
                  //     ? "bg-[#DBEAFE] text-[#1D4ED8]"
                  //     : item.value === "Ready for Provider"
                  //     ? "bg-[#DBEAFE] text-[#1D4ED8]"
                  //     : "bg-[#ECECEE] text-[#1D4ED8]" // default
                  // }`}
                  onClick={() => handleButtonClick(item.value)}
                >
                  {item.value}
                </button>
              ))}
            </div>
          
            {/* Separate for other labels */}
<div className="grid grid-cols-2 gap-2 w-full">

              {statusOptions.filter(item => 
                !['Rescheduled', 'Cancelled',"No Update", 'ACTIVE', 'No Show', 'In-Office - Confirmed', "Tele - Confirmed","Tele - left VM","In-Office - left VM", "In-office - Checked In","Awaiting Check In"].includes(item.value)
              ).map((item) => (
                <button
                  key={item.value}
              className={`py-[8px] px-2 rounded-full text-[14px] font-inter transition duration-300 ease-in-out
  ${
    selectedOption === item.value
      ? "bg-black text-white ring-2 ring-black"
      : item.value === "Ready for Triage"
      ? "bg-[#F0FDF4] text-[#50869A]"
      : item.value === "Checked Out"
      ? "bg-[#E1795459] text-[#C2410C]"
      : item.value === "Processing"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : item.value === "Ready for Checkout"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : item.value === "Ready for Provider"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : "bg-[#ECECEE] text-[#1D4ED8]"
  }
`}

                  onClick={() => handleButtonClick(item.value)}
                >
                  {item.value}
                </button>
              ))}
              <button   onClick={() => handleButtonClick("Ready for Checkout")}    className={`py-[8px] px-2 w-[90%] rounded-full text-[14px] font-inter transition duration-300 ease-in-out ${
  selectedOption === "Ready for Checkout"
    ? "bg-black text-white ring-2 ring-black"
    : "bg-[#DBEAFE] text-[#1D4ED8]"
}`}

                >
              Ready for Checkout
              </button>
            </div>
          </div>
          
          )}

          {/* Apply and Cancel buttons */}
          <div className="w-full flex justify-between mt-4 p-2">
            {loading ? (
              <Skeleton
                variant="rectangular"
                width="40%"
                height={40}
                sx={{ borderRadius: "20px" ,margin:'10px'}}
              />
            ) : (
              <>
           
                {/* <button
                  onClick={handleCancelClick}
                  className="rounded py-[10px] text-[14px] font-Font1 px-2 w-[48%] transition duration-300 ease-in-out   text-[black] border-[1.5px] border-gray-200"
                >
                  Clear ALL
                </button> */}
                <button
                  onClick={handleApplyClick}
                  className="rounded py-[10px] text-[14px] font-Font1 px-2 w-full transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] bg-[black] text-[#FFFFFF]"
                >
                  Update Status
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default StatusPopup;
